import {
  UserInfoRequest,
  UserInfoStore,
  USER_INFO_RETRIEVE_START,
  USER_INFO_RETRIEVE_SUCCESS,
  USER_INFO_RETRIEVE_FAILED,
  USER_INFO_REGISTER_START,
  USER_INFO_REGISTER_SUCCESS,
  USER_INFO_REGISTER_FAILED,
  USER_INFO_UPDATE_START,
  USER_INFO_UPDATE_SUCCESS,
  USER_INFO_UPDATE_FAILED
} from './types';

export const userInfo = (
  state: UserInfoStore = {
    retrieveError: null,
    submitError: null
  },
  action: {
    type: string;
    payload?: unknown;
  }
): UserInfoStore => {
  switch (action.type) {
    case USER_INFO_RETRIEVE_START:
      return {
        ...state,
        retrieveLoading: true,
        retrieveError: null,
        submitError: null,
        formData: null,
        data: null
      };
    case USER_INFO_REGISTER_START:
    case USER_INFO_UPDATE_START:
      return {
        ...state,
        submitLoading: true,
        submitError: null,
        data: null
      };
    case USER_INFO_RETRIEVE_FAILED:
      return {
        ...state,
        submitLoading: false,
        retrieveLoading: false,
        formData: null,
        retrieveError: action.payload
      };
    case USER_INFO_REGISTER_FAILED:
    case USER_INFO_UPDATE_FAILED:
      return {
        ...state,
        submitLoading: false,
        retrieveLoading: false,
        submitError: action.payload
      };
    case USER_INFO_RETRIEVE_SUCCESS:
      return {
        ...state,
        retrieveLoading: false,
        retrieveError: null,
        formData: action.payload as UserInfoRequest
      };
    case USER_INFO_REGISTER_SUCCESS:
    case USER_INFO_UPDATE_SUCCESS:
      return {
        ...state,
        submitLoading: false,
        submitError: null,
        data: action.payload as UserInfoRequest
      };
    default:
      return state;
  }
};
